<template>
  <div class="language-mobile-menu-backdrop">
    <navbar-mobile-header
      @close="$emit('close')"
      theme="blue"
    />

    <div class="container language-mobile-content">

      <div class="language-mobile-section-title">{{ $t('language_menu.choose_language') }}</div>

      <div 
        @click="setLanguage('fr')"  
        class="language-mobile-button"
      >
        <div class="language-mobile-button-text" :style="languageButtonStyle('fr')">Français</div>
      </div>
      <div 
        @click="setLanguage('en')"
        class="language-mobile-button"
      >
        <div class="language-mobile-button-text" :style="languageButtonStyle('en')">English</div>
      </div>
      
      <div 
        @click="setLanguage('de')"
        class="language-mobile-button"
      >
        <div class="language-mobile-button-text" :style="languageButtonStyle('de')">Deutsch</div>
      </div>
      
      <div 
        @click="setLanguage('es')"
        class="language-mobile-button"
      >
        <div class="language-mobile-button-text" :style="languageButtonStyle('es')">Español</div>
      </div>

      <div class="language-mobile-divider"></div>

      <div class="language-mobile-section-title">{{ $t('language_menu.choose_currency') }}</div>

      <div
        v-for="curr in currencies"
        :key="curr.code"
        @click="setCurrency(curr.code)"
        class="language-mobile-button"
      >
        <div class="language-mobile-button-text" :style="currencyButtonStyle(curr.code)">{{ curr.label }}</div>
      </div>

    </div>
  </div>
</template>

<script>
import NavbarMobileHeader from '../navbar/NavbarMobileHeader.vue';
export default {
  components: { NavbarMobileHeader },
  data() {
    return {
      currencies: [
        { code: 'EUR', label: 'Euro (€)' },
        { code: 'USD', label: 'US dollars ($)' },
      ],
    }
  },
  computed:{
    language () {
      return this.$i18n.locale
    },
    currentCurrency () {
      return this.$store.state.currency
    }
  },
  methods: {
    languageButtonStyle(language) {
      return language === this.language ? `color: white;` : ''
    },
    currencyButtonStyle(code) {
      return code === this.currentCurrency ? `color: white;` : ''
    },
    setLanguage(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      this.$emit('close')
    },
    setCurrency(code) {
      this.$store.commit('setCurrency', code);
      this.$emit('close')
    }
  },
};
</script>

<style>
  
.language-mobile-menu-backdrop {
  background-color: #4179af;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  overflow-y: auto;
}

.language-mobile-content {
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.language-mobile-section-title {
  font-size: 0.8rem;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-top: 20px;
  margin-bottom: 5px;
  align-self: center;
  text-align: center;
}

.language-mobile-divider {
  width: 100%;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  margin: 20px 0 0;
}

.language-mobile-button {
  cursor: pointer;
  position: relative;
  margin-top: 20px;
}
.language-mobile-button-text {
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.45);
  text-align: center;
}
</style>